import { CommonOption } from "api/modules/common.option";
import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

  export const vacutainerLabelFields = (
    studyOptions: CommonOption[],
    periodOptions: CommonOption[],
    timepointOptions: CommonOption[],
    selectedStudyId: string | number | null
  ): FormFieldConfig[] => [
    {
      name: "studyid",
      label: "Study Code",
      type: "select",
      options: studyOptions,
      placeholder: "Select Study Code",
      required: true,
      disabled: true,
      rules: validations.vacutainerLabel.studyid,
    },
    {
      name: "period",
      label: "Period",
      type: "select",
      options: periodOptions,
      placeholder: "Select Period",
      disabled: !selectedStudyId,
      required: true,
      rules: validations.vacutainerLabel.period,
    },
    {
      name: "timepoint",
      label: "Timepoint",
      type: "select",
      options: timepointOptions,
      placeholder: "Select Timepoint",
      disabled: !selectedStudyId,
      required: true,
      rules: validations.vacutainerLabel.timepoint,
    },
  ];

 export const vacutainerLabelColumns = (
    selectedAssignmentIds: number[],
    toggleSelection: (data: any, checked: boolean) => void,
    isAllSelected?: boolean,
    handleSelectAll?: (isChecked: boolean) => void
  ) => [
    {
      key: "select",
      sticky: true,
      width: "50px",
      label: (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={isAllSelected || false}
            onChange={(e) => handleSelectAll?.(e.target.checked)}
          />
        </div>
      ),
      textCenter: true,
      render: (_: any, data: any) => (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={selectedAssignmentIds.includes(data.samplecollectionid)}
            onChange={(e) => toggleSelection(data, e.target.checked)}
          />
        </div>
      ),
    },
    {
      key: "subjectno",
      label: "Subject No",
      sticky: true,
      width: "110px",
      render: (val: any) =>
        Number(val) >= 1 && Number(val) <= 9
          ? String(val).padStart(2, "0")
          : val,
    },
    {
      key: "period_number",
      label: "Period",
    },
    {
      key: "timepoint_number",
      label: "TimePoint",
    },
    {
      key: "vialbarcode",
      label: "Barcode",
    },
  ];